import React from "react";
import { 
  FaQuoteLeft, 
  FaQuoteRight, 
  FaArrowRight, 
  FaGraduationCap, 
  FaBook, 
  FaUsers,
  FaStar,
  FaCheckCircle
} from "react-icons/fa";
import { GiNurseFemale } from "react-icons/gi";
import { MdVerified } from "react-icons/md";
const PrincipalMessageSection = () => {
  return (
    <section className="py-16 px-4 bg-gradient-to-br from-slate-50 via-white to-slate-100">
      <div className="max-w-7xl mx-auto">
        
        <div className="text-center mb-12">
          <div className="flex justify-center mb-4">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-100 text-blue-700 text-sm font-semibold">
              <GiNurseFemale className="text-lg" />
              From the Principal's Desk
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-blue-700 to-green-600 bg-clip-text text-transparent">
              Principal's Message
            </span>
          </h2>
        </div>
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-200">
          <div className="h-2 bg-gradient-to-r from-blue-600 to-green-600"></div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 p-8 lg:p-10">
            <div className="lg:col-span-1">
              <div className="sticky top-8">
                <div className="relative mb-6">
                  <div className="absolute -bottom-3 left-5 right-5 h-4 bg-gray-300/50 blur-sm rounded-full"></div>
                  <div className="absolute -bottom-2 left-3 right-3 h-3 bg-gray-400/30 blur-md rounded-full"></div>
                  
                  <img 
                    src="/image.png" 
                    alt="Dr.Salina Pathak, Principal"
                    className="w-full h-auto block relative z-10 rounded-2xl"
                  />
                </div>
                <div className="text-center">
                  <h3 className="text-2xl font-bold text-gray-800">Dr.Salina Pathak</h3>
                  <p className="text-blue-600 font-medium">Principal</p>
                  <p className="text-sm text-gray-500 mt-1">M.Sc. Nursing, Ph.D.</p>
                  <div className="mt-4 inline-flex items-center gap-1 bg-blue-50 px-3 py-1.5 rounded-full">
                    <FaStar className="text-blue-600 text-xs" />
                    <span className="text-xs text-blue-700 font-medium">33+ Years Experience</span>
                  </div>
                </div>
                <div className="mt-6 flex justify-center gap-2">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                    <FaGraduationCap className="text-blue-600 text-sm" />
                  </div>
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                    <FaBook className="text-green-600 text-sm" />
                  </div>
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                    <FaUsers className="text-blue-600 text-sm" />
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:col-span-2">
              <div className="mb-4">
                <FaQuoteLeft className="text-5xl text-blue-200" />
              </div>
              <div className="space-y-6 text-gray-700">
                <p className="text-lg leading-relaxed font-medium text-gray-800">
                  "Education is not just about degrees; it's about transforming lives and shaping character."
                </p>
                <p className="leading-relaxed">
                  Welcome to R.D.S. NURSING & PARAMEDICAL COLLEGE. As Principal, I am proud to lead an institution 
                  that has been at the forefront of healthcare education for over two decades. Our commitment 
                  to excellence, combined with compassionate care, sets us apart in the field of nursing and 
                  pharmaceutical sciences.
                </p>
                <p className="leading-relaxed">
                  At RDS, we focus on holistic development of our students. Our curriculum is designed to 
                  provide not just theoretical knowledge but also practical skills through hands-on training 
                  in our state-of-the-art labs and affiliated hospitals. We believe in nurturing not just 
                  competent professionals, but compassionate human beings who will make a difference in the 
                  lives of their patients.
                </p>
                <div className="grid grid-cols-2 gap-4 my-6">
                  <div className="bg-blue-50 p-4 rounded-xl">
                    <p className="text-2xl font-bold text-blue-600">100%</p>
                    <p className="text-xs text-gray-600">University Results</p>
                  </div>
                  <div className="bg-green-50 p-4 rounded-xl">
                    <p className="text-2xl font-bold text-green-600">95%</p>
                    <p className="text-xs text-gray-600">Placement Record</p>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-blue-50 to-green-50 p-6 rounded-xl italic border-l-4 border-blue-600">
                  <FaQuoteRight className="text-2xl text-blue-400 ml-auto mb-2" />
                  <p className="text-gray-700">
                    "I invite you to join our family and embark on a rewarding journey in healthcare. 
                    Together, we will build a healthier tomorrow."
                  </p>
                </div>
              </div>
              <div className="mt-8 flex flex-wrap items-center justify-between gap-4">
                <div>
                  <p className="font-semibold text-gray-800">Dr.Salina Pathak</p>
                  <p className="text-sm text-gray-500">Principal, R.D.S. NURSING & PARAMEDICAL COLLEGE</p>
                </div>
                <button className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-green-600 text-white font-medium rounded-xl hover:from-blue-700 hover:to-green-700 transition-all duration-300">
                  Read Full Message <FaArrowRight className="text-sm" />
                </button>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 p-4 border-t border-gray-100">
            <div className="flex flex-wrap justify-around gap-4">
              <div className="flex items-center gap-2">
                <MdVerified className="text-blue-600" />
                <span className="text-sm text-gray-700">Best Nursing College Award 2023</span>
              </div>
              <div className="flex items-center gap-2">
                <MdVerified className="text-green-600" />
                <span className="text-sm text-gray-700">Excellence in Healthcare Education</span>
              </div>
              <div className="flex items-center gap-2">
                <FaCheckCircle className="text-blue-600" />
                <span className="text-sm text-gray-700">NAAC A+ Grade</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrincipalMessageSection;